import { render, staticRenderFns } from "./LogPost.vue?vue&type=template&id=40b6d91c&scoped=true&lang=pug&"
import script from "./LogPost.vue?vue&type=script&lang=js&"
export * from "./LogPost.vue?vue&type=script&lang=js&"
import style0 from "./LogPost.vue?vue&type=style&index=0&id=40b6d91c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6d91c",
  null
  
)

export default component.exports